import { Component } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  selector: 'miq-text-area-input',
  templateUrl: './text-area-input.component.html',
  standalone: false,
})
export class AdvancedTextAreaInputComponent extends AbstractAdvancedInput {}
